import { useState, useEffect } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import paymentService from '../../services/payment.service';

const CheckoutForm = ({ eventId, onSuccess, onError }) => {
    const stripe = useStripe();
    const elements = useElements();

    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!stripe) {
            return;
        }

        const clientSecret = new URLSearchParams(window.location.search).get(
            'payment_intent_client_secret'
        );

        if (!clientSecret) {
            return;
        }

        stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
            switch (paymentIntent.status) {
                case 'succeeded':
                    setMessage('Pago realizado con éxito');
                    break;
                case 'processing':
                    setMessage('Su pago se está procesando.');
                    break;
                case 'requires_payment_method':
                    setMessage('Su pago no se realizó, intente de nuevo.');
                    break;
                default:
                    setMessage('Algo salió mal.');
                    break;
            }
        });
    }, [stripe]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            return;
        }

        console.log('[CheckoutForm] Iniciando confirmación de pago...');
        setIsLoading(true);

        const { error, paymentIntent } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                // Make sure to change this to your payment completion page
                return_url: `${window.location.origin}/event/${eventId}`,
            },
            redirect: 'if_required', // Important to avoid full page reload if not needed
        });

        console.log('[CheckoutForm] Respuesta de stripe.confirmPayment:', { error, paymentIntent });

        if (error) {
            if (error.type === 'card_error' || error.type === 'validation_error') {
                setMessage(error.message);
                if (onError) onError(error.message);
            } else {
                setMessage('Ocurrió un error inesperado.');
                if (onError) onError('Ocurrió un error inesperado.');
            }
        } else {
            // Success
            if (onSuccess) onSuccess(paymentIntent);
        }

        setIsLoading(false);
    };

    const paymentElementOptions = {
        layout: 'tabs',
    };

    return (
        <form id="payment-form" onSubmit={handleSubmit} className="w-full">
            <PaymentElement id="payment-element" options={paymentElementOptions} />
            <button
                disabled={isLoading || !stripe || !elements}
                id="submit"
                className="w-full mt-4 bg-primary-600 text-white font-bold py-2 px-4 rounded hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
                <span id="button-text">
                    {isLoading ? <div className="spinner" id="spinner">Procesando...</div> : 'Pagar ahora'}
                </span>
            </button>
            {message && <div id="payment-message" className="mt-4 text-red-500 text-sm text-center">{message}</div>}
        </form>
    );
};

export default CheckoutForm;
